import clsx from "clsx";
import React, { ReactElement, ReactNode, isValidElement } from "react";
import "./CustomContainer.scss";

type ScrollOption = "full" | "content" | "hidden";

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "light" | "dark" | "custom";
  backgroundColor?: string;
  textColor?: string;
  className?: string;
  children?: ReactNode;
  scroll?: ScrollOption;
  onClick?: () => void;
}

const Container: React.FC<ContainerProps> = ({
  variant = "light",
  backgroundColor,
  textColor,
  className = "",
  children,
  onClick,
  scroll = "hidden",
  ...rest
}) => {
  const classNames = `custom-container ${variant} scroll-${scroll} ${className}`.trim();

  const customStyle =
    variant === "custom"
      ? {
          backgroundColor: backgroundColor || "#ffffff",
          color: textColor || "#000000"
        }
      : {};

  const childArray = React.Children.toArray(children);
  const header = childArray[0];
  const content = childArray[1];

  const renderContent = () => {
    if (isValidElement(content) && content.type === "div") {
      const element = content as ReactElement<React.HTMLAttributes<HTMLDivElement>>;

      return React.cloneElement(element, {
        className: clsx("custom-container-scrollable-content", element.props.className),
        style: { ...element.props.style }
      });
    }

    return <div className="custom-container-scrollable-content">{content}</div>;
  };

  if (scroll === "content") {
    return (
      <div className={classNames} style={customStyle} {...rest}>
        <div className="custom-container-header">{header}</div>
        {renderContent()}
      </div>
    );
  }

  return (
    <div className={classNames} style={customStyle} {...rest} onClick={onClick}>
      {children}
    </div>
  );
};

export default Container;
